// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportModalFilter_root__2YOlN","footer":"ReportModalFilter_footer__24qu0"};